<template>
  <div class="plv-ia-qn-nocontent">
    <p>{{ t('plvIA.questionnaire.notCreated') }}</p>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
export default {
  mixins: [Locale],
};
</script>

<style lang="scss">
$imgPrefix: './images/';

.plv-ia-qn-nocontent {
  padding-top: 280px;
  color: #333;
  font-size: 14px;
  background: url($imgPrefix + 'no-content.png') no-repeat;
  background-position: center 200px;
  background-size: 60px;
  text-align: center;
  margin: 0 auto;
}
</style>
